module.exports = __webpack_public_path__ + "static/media/Formular-Light.8fcbbf71.woff2";